module.exports = __webpack_public_path__ + "static/media/auto_pecas.583a4952.jpg";